import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmEmailRequestsRoute: InvariantJiraRoute = {
	name: 'products-jsm-email-requests',
	path: '/jira/settings/products/jira-service-management-email-requests',
	exact: true,
};
